/** Objects parsing */

/**
 * Parse object and return new one with only number keys (parsed if it's need)
 * @param {Object} obj Origin object
 * @returns Object with parsed number keys
 */
export const parseObjectNumberProps = obj => {
  const objectEntries = Object.entries(obj);
  const numberEntries = objectEntries.filter(
    ([, val]) => isFinite(val) && ["string", "number"].includes(typeof val)
  );
  const parsedEntries = numberEntries.map(([key, val]) => [key, Number(val)]);
  const newObject = Object.fromEntries(parsedEntries);
  return newObject;
};

/**
 * Get object with <key:value> pairs and return array of simple objects
 * (one per origin property) with next form: { id: <key>, valueName: <value> }
 * @param {Object} obj Origin object
 * @param {String} valueName name for property value key
 * @returns {Array}
 */
export const parseObjectToPropsArray = (obj, valueName) => {
  return Object.entries(obj).map(([id, value]) => ({
    id: id,
    [valueName]: value
  }));
};

/**
 * Return array of elements filtered by identifiers
 * Example:
 *  array = [{ name: "apples", count: 12 }, { name: "ananas", count: 2 }]
 *  ids = ["apples", "oranges"]
 *  getId = (food) => food.name
 *  Returns - [{ name: "apples", count: 12 }]
 * @param {Array} array Filtering elements
 * @param {Array} ids Required IDs
 * @param {Function} getId ID getter that map array elements to IDs
 * @returns {Function} Filtered array
 */
export const filterArrayByIds = (array, ids, getId) => {
  const sampleSet = new Set(ids);
  return array.filter(el => sampleSet.has(getId(el)));
};

/**
 * Use function for each element of array and return array of results
 * @param {Array} array Array to map
 * @param {Function} handler Handler function that returns Promise object
 * @returns {Promise} Promise that's return array of results
 */
export const mapAsync = (array, handler) => {
  const promises = array.map(async el => handler(el));
  return Promise.all(promises);
};

export const getRange = (start = 0, max, step = 1) => {
  const range = [];

  for (let n = start; n <= max; n += step) {
    range.push(n);
  }

  return range;
};

export const parseValidNumberOrDefault = (input, defaultNumber) => {
  const num = Number(input);
  if (Number.isNaN(num)) return defaultNumber;
  return num;
};
